import {Inject, Pipe, PipeTransform, PLATFORM_ID} from '@angular/core';
import {isEnvironmentLocal} from "@core/utils";
import {environment} from "@environments/environment";


/**
 * Xử lý chuyển đổi linkCdn ảnh tĩnh trong project
 * */
@Pipe({
  name: 'imgCdn',
  standalone: true
})
export class ImgCdnPipe implements PipeTransform {
  constructor(
    @Inject(PLATFORM_ID) private platformId: object
  ) {
  }

  transform($filePath: string) {
    if (!$filePath) {
      return '';
    }

    // Nếu là link tuyệt đối (http...) thì giữ nguyên
    if ($filePath.startsWith('http')) {
      return $filePath;
    }

    // Nếu đường dẫn bắt đầu bằng /img/ hoặc img/ (db lưu logo dạng /img/logo/...)
    // thì thêm /assets vào trước để trỏ đúng thư mục build
    if ($filePath.startsWith('/img/') || $filePath.startsWith('img/')) {
      $filePath = '/assets/' + $filePath.replace(/^\//, '');
    }

    // Lấy prefix từ environment (Local: assets/img/, Pro: https://vpage.static.nvncdn.com/assets/img/)
    const $serverPath = environment.cloudStorageStatic.vpageStaticUrl;

    // Nếu đường dẫn bắt đầu bằng assets/ thì ta trỏ về folder assets trong build output
    if ($filePath.startsWith('assets/') || $filePath.startsWith('/assets/')) {
      // Nếu là local thì trả về nguyên bản (vì angular serve phục vụ từ gốc)
      if (isEnvironmentLocal(this.platformId)) {
        return $filePath;
      }

      const $cleanPath = $filePath.startsWith('/') ? $filePath.substring(1) : $filePath;
      return `${$cleanPath}?v=1`;
    }

    // Các trường hợp còn lại (truyền vào tên file hoặc subpath của thư mục img vpage)
    return `${$serverPath}${$filePath}`;
  }
}
